module.exports = new __parcel__URL__("alerts-task-four-illustration.dd0ac676.png").toString();